export default {
    props: {
        name: {type: String, required: true},
        label: {type: String, default: null},

        // type: undefined => Any
        value: {type: undefined, default: null},

        required: {type: Boolean},
        translatable: {type: Boolean},
        hideValidation: {type: Boolean},

        serverErrors: {type: [Object, Array], default: null},

        asRow: {type: Boolean},
        size: {
            type: String,
            default: null,
            validator: (value) => ['sm', 'lg'].indexOf(value) !== -1,
        },
    },

    data() {
        return {
            modelErrors: [],
        };
    },

    computed: {
        model: {
            get() {
                return this.format(this.value);
            },
            set(value) {
                const parsed = this.parse(value);

                this.$emit('input', parsed);

                // pass value for custom cases, see: MaskedFieldMixin
                this.updateDisplayValue(value);
            },
        },

        errors() {
            const serverErrors = Array.isArray(this.serverErrors)
                ? this.serverErrors
                : (this.serverErrors && this.serverErrors[this.name] || []);

            return [...serverErrors, ...this.modelErrors];
        },

        isValid() {
            return this.errors.length === 0;
        },

        showValidation() {
            return !this.isValid && !this.hideValidation;
        },

        inputClass() {
            if (this.size === null) {
                return null;
            }

            return `form-control-${this.size}`;
        },
    },

    watch: {
        model: {
            immediate: true,
            handler(newValue, oldValue) {
                if (!this.compareValue(newValue, oldValue)) {
                    this.validate(newValue);
                }
            },
        },

        isValid: {
            // immediate: true, // bugs ios 12.2+
            handler(isValid) {
                this.$emit('validation', isValid === true);
            },
        },

        required() {
            this.validate(this.model);
        },
    },

    mounted() {
        // hack to ios 12.2+ bug
        this.$emit('validation', this.isValid);
    },

    methods: {
        parse(value) {
            // STUB - you should overwrite it

            // the value that will be emitted
            return this.format(value);
        },

        format(value) {
            // STUB - you should overwrite it

            // the value that will be shown in the input
            return value || null;
        },

        /* eslint-disable-next-line no-unused-vars */
        updateDisplayValue(value) {
            // can keep formatted value
        },

        validate(value) {
            // STUB - you should overwrite it
            const errors = [];

            if (this.required && (value === null)) {
                errors.push(this.$t('validation.custom.required'));
            }

            this.modelErrors = errors;
        },

        compareValue(newValue, oldValue) {
            return newValue === oldValue;
        },

        focus() {
            if (this.$refs.input) {
                this.$nextTick(() => {
                    this.$refs.input.focus();
                });
            }
        },
    },
};
